import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { 
  MessageSquare, 
  Upload, 
  LogOut, 
  Menu,
  X,
  Shield,
  History
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import '../assets/css/layout.css';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false); // Mobile toggle state (desktop sidebar is always visible via CSS)
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/query', icon: MessageSquare, label: 'Ask Nick' },
    { path: '/history', icon: History, label: 'History' },
    { path: '/upload', icon: Upload, label: 'Upload' },
  ];

  // Add Admin Dashboard for admins only
  if (user?.role === 'admin') {
    navItems.push({ path: '/admin', icon: Shield, label: 'Admin' });
  }

  const handleNavClick = (path) => {
    navigate(path);
    setSidebarOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getPageTitle = () => {
    const currentPath = location.pathname;
    const item = navItems.find(item => item.path === currentPath);
    return item ? item.label : 'Nick';
  };

  return (
    <div className={`layout-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
      <div className={`overlay ${sidebarOpen ? 'show' : ''}`} onClick={() => setSidebarOpen(false)} />

      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-content">
          <div className="logo">
            <img className="fluid-dynamics-logo-img" src="/FluidDynamics-Logo.png" alt="FluidDynamics" />
          </div>

          <nav className="nav">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <div
                  key={item.path}
                  className={`nav-item ${isActive ? 'is-active' : ''}`}
                  onClick={() => handleNavClick(item.path)}
                >
                  <div className="nav-icon">
                    <Icon size={20} />
                  </div>
                  <span className="nav-text">{item.label}</span>
                </div>
              );
            })}
          </nav>

          <div className="user-section">
            <div className="user-info">
              <div className="user-avatar">
                {user?.name?.charAt(0)?.toUpperCase()}
              </div>
              <div className="user-details">
                <div className="user-name">{user?.name}</div>
                <div className="user-role">{user?.role}</div>
              </div>
            </div>

            <button className="logout-button" onClick={handleLogout}>
              <LogOut size={16} />
              Logout
            </button>
          </div>
        </div>
      </aside>

      <main className="main-content">
        <header className="header">
          <div className="header-left">
            <button className="mobile-menu-button" onClick={() => setSidebarOpen(!sidebarOpen)}>
              {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
            <h2 className="page-title">{getPageTitle()}</h2>
          </div>
        </header>

        <div className="content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
